import React from "react";
import ListCompanyContainer from "../../containers/ListCompany";

const ListCompanyScreen = () => {
  return <ListCompanyContainer />;
};

export default ListCompanyScreen;
